import { request } from 'graphql-request';
import { Fetcher } from 'swr';
import useSWRMutation from 'swr/mutation';

import config from '@/core/config/config';
import { INSERT_LEAD } from '@/graphql/mutations/apps/insertLead';
import { NewsletterSignUpType } from '@/types';

const mutationFetcher: Fetcher<any, [any, any]> = async ([query, variables]) => {
  return await request(variables ? config.PII_PUBLIC_SERVER : '', query, variables);
};

export const useInsertLead = ({ newsletterSignUp }: { newsletterSignUp: NewsletterSignUpType }) => {
  const payload = {
    leadInput: {
      ...newsletterSignUp,
      campaign: 'WEB_Footer',
      country: '',
      leadSource: '',
      leadType: 'Member',
      status: 'New',
      company: 'RemoveMe',
    },
  };
  return useSWRMutation([INSERT_LEAD, payload], mutationFetcher);
};
